module.exports = __webpack_public_path__ + "img/cookies.87b99da2.svg";